import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-service-level-update',
    templateUrl: './service-level-update.component.html',
    styleUrls: ['./service-level-update.component.css'],
    standalone: false
})
export class ServiceLevelUpdateComponent implements OnInit {

    constructor(
        private titleService: Title
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Service Level Update');
    }

}
